const es = {
    translation: {
        button: {
            back: 'Atrás',
            backToAccountServices: 'REGRESAR A SERVICIOS DE CUENTA',
            cancel: 'CANCELAR',
            changeDueDate: 'Cambiar Fecha de Vencimiento',
            close: 'CERRAR',
            creditLimitIncrease: 'Aumento del Límite de Crédito',
            submit: 'Enviar'
        },
        changePaymentDueDate: {
            changePaymentDueDate: 'Cambiar fecha de vencimiento de pago',
            modalHeader: 'Cambiar Fecha de Vencimiento'
        },
        errorMessages: {
            accessDeniedMessageBox: {
                body: 'Por favor llame al (800) 508-2520 para obtener ayuda. Siempre estamos disponibles para ayudar; llámenos las 24 horas, los 7 días de la semana.',
                title: 'Estamos teniendo problemas para verificar su identidad'
            },
            addPrimaryHolder: {
                extraInfo: 'Intente nuevamente con otro nombre.',
                subTitle: 'Usted ingresó un nombre de Titular de Tarjeta que ya tiene una tarjeta.',
                title: 'Por favor, vuelva a intentarlo'
            },
            addressChanged: 'No podemos tramitar su solicitud porque su dirección ha cambiado en los últimos 30 días.',
            dueDateChangePeriodRestriction: {
                subTitle: 'Puede cambiar su fecha de vencimiento una vez cada 12 meses.',
                title: 'Usted no puede cambiar su fecha de vencimiento ahora mismo'
            },
            nameChanged: 'No podemos tramitar su solicitud porque ha cambiado su nombre en los últimos 30 días.',
            notEligible: {
                body: 'En este momento no podemos procesar su solicitud de Cambiar la Fecha de Vencimiento.',
                title: 'Su cuenta no es elegible'
            },
            notEligibleAccount: 'Su cuenta no es elegible',
            profanity: {
                title: 'Por favor, vuelva a intentarlo',
                unapprovedName: 'El nombre o nombres que nos ha proporcionado no pudieron ser aceptados tal como fueron ingresados. Por favor, realice las correcciones necesarias y vuelva a intentarlo.'
            },
            troubleAccessingAccount: 'Tenemos problemas para acceder a su cuenta',
            troubleRetrievingInformation: 'Tenemos problemas para recuperar su información',
            tryAgainLater: 'Por favor, vuelva a intentarlo más tarde.'
        },
        mocks: {
            accountEnding: 'Cuenta que termina en {{accountLast4}}',
            availableToSpend: 'Disponible para gastar',
            beginLogin: 'Iniciar sesión',
            cardAccountEnding: 'Tarjeta para cuenta que termina en {{accountLast4}}',
            clientId: 'Ingrese una identificación de cliente',
            currentBalance: 'Saldo Actual',
            environment: 'Elige un entorno',
            logout: 'cerrar sesión',
            makeAPayment: 'Realizar un pago',
            paymentDueDate: 'Fecha de vencimiento del pago',
            totalMinimumPayment: 'Pago Mínimo Total'
        },
        modal: {
            closeDialog: 'Cerrar diálogo',
            header: 'Aumento del Límite de Crédito'
        },
        text: {
            accountActions: 'Acciones de cuenta',
            accountServices: 'Servicios de cuenta',
            manageCardHolders: 'Administrar titulares de tarjetas',
            paymentSecurity: 'Payment Security',
            balanceTransferOffers: 'Ofertas de transferencia de saldo'
        }
    }
};
export default es;
